module.exports = function clearer(color) {
  color.installMethod('clearer', function (amount) {
    return this.alpha(isNaN(amount) ? -0.1 : -amount, true);
  });
};
